<template>
  <v-btn
    icon
    v-bind="$attrs"
    v-on:click.stop="$_onClicked()"
  >
    <v-icon>mdi-play-box</v-icon>
  </v-btn>
</template>

<script>
import { TimelineSegmentId, providedFunctions } from '@Scatt'

export default {
  props: {
    cefrScoreTimelineSegmentId: { type: TimelineSegmentId },
  },

  inject: providedFunctions,

  methods: {
    $_onClicked() {
      this.clearSelectedTimelineSegments();
      this.selectTimelineSegments(this.cefrScoreTimelineSegmentId);
      this.invokeActionOnSelectedTimelineSegments('setMarker');
      this.invokeActionOnSelectedTimelineSegments('seek');
    },
  },
};
</script>